<template>
  <MessageOpenSection
    :messages_view="messages_view"
    :webmail_view ="webmail_view"
    :viewport_controller="viewport_controller"
    :folder_id="folder_id"
  />

  <FoldersSelectModal v-if="folders_move_visible === true"
    @folderSubmit="onMessagesMoveSubmit"
    @folderSubmitCancel="onMessagesMoveCancel"
    button_submit_text="messages.actions.move_message"
  />
</template>

<script setup>
  import {ref, defineProps} from 'vue';
  import {onBeforeMount}    from 'vue';
  import MessageOpenSection from './Sections/MessageOpenSection.vue';
  import PopupController    from '@/js/Webmail/PopupController';

  const props = defineProps({
    webmail_view : {},
  });

  const messages_view          = ref();
  const viewport_controller    = ref();
  const folder_id              = ref();
  const folders_move_visible   = ref(false);

  onBeforeMount(() => {
    setProps();
  })

  const setProps = () => {
    let data                  = PopupController.getPopupData();
    viewport_controller.value = data.viewport_controller;
    messages_view.value       = data.messages_view;
    folder_id.value           = data.folder_id;
  }
</script>
